/**
 * Displays the answer to a question. It formats currency values with a $ and appends percentage values with a %
 * Pipe can be applied to both static values and form control dynamic values
 */

import { Pipe, PipeTransform } from "@angular/core";
import { CurrencyPipe } from "@angular/common";
import { IFormField } from "../components/form-field-wrapper/form-field-wrapper.component";
import { ConfigStateService } from "../../app/config/config-state.service";

@Pipe({
    name: "answerDisplay",
    standalone: false
})
export class AnswerDisplayPipe implements PipeTransform {
  constructor(
    private currencyPipe: CurrencyPipe,
    private config: ConfigStateService
  ) {}

  transform(question: IFormField, formCtrlValue?: string): any {
    const answer = formCtrlValue != null ? formCtrlValue : "";
    if (answer === "") {
      return "";
    } else if (question.isCurrency) {
      const n = Number(answer);
      if (Number.isNaN(n)) return answer;
      else return this.config.featureFlags.useCurrencyFormatter 
        ? new Intl.NumberFormat(navigator.language, { style: 'currency', currency: 'USD' }).format(n) 
        : this.currencyPipe.transform(n);
    } else if (question.isPercentage) {
      return answer + "%";
    } else if (question.displayFieldType === "image") {
      const filename = answer.replace(/^.*[\\\/]/, "");
      const filenameWithExtension = filename.split(/_(.+)/)[1];
      return filenameWithExtension;
    } else if (question.displayFieldType === "file") {
      const filename = JSON.parse(answer)?.docId?.replace(/^.*[\\\/]/, '');
      return filename.replace(/(.+)_.+(.{6})\.(.+)/, "$1...$2.$3");
    } else {
      return answer;
    }
  }
}
